const FORUM_SSO_KEY = 'forum_sso'

export const saveForumSso = (sso, sig) => {
  if (!sso || !sig) return
  sessionStorage.setItem(FORUM_SSO_KEY, JSON.stringify({ sso, sig }))
}

export const peekForumSso = () => {
  try {
    const raw = sessionStorage.getItem(FORUM_SSO_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const clearForumSso = () => sessionStorage.removeItem(FORUM_SSO_KEY)

export const hasForumSso = () => {
  const pending = peekForumSso()
  return !!(pending?.sso && pending?.sig)
}

export const completeForumSso = async (accessToken) => {
  const pending = peekForumSso()
  if (!pending?.sso || !pending?.sig || !accessToken) return false

  const response = await fetch(process.env.REACT_APP_API_DOMAIN + '/forum/connect/complete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
    body: JSON.stringify({ sso: pending.sso, sig: pending.sig }),
  })
  const resData = await response.json()
  if (!response.ok || resData.error !== 0 || !resData.data?.redirectUrl) {
    clearForumSso()
    throw new Error(resData.message || 'Не удалось войти на форум')
  }
  clearForumSso()
  window.location.href = resData.data.redirectUrl
  return true
}

export const openForumSso = () => {
  const base = (process.env.REACT_APP_FORUM_URL || '').replace(/\/$/, '')
  if (!base) {
    console.warn('REACT_APP_FORUM_URL is not set')
    return
  }
  window.open(`${base}/session/sso`, '_blank')
}
